import platformUtils from '../platformUtils';
import _ from 'lodash';

function getMainPage(siteStructure) {
    return _.find(siteStructure.pages, {isMainPage: true});
}

function getPageIdByLightboxName(siteStructure, name) {
    const lightbox = _.find(siteStructure.lightboxes, {name});
    return _.get(lightbox, 'id');
}

function getPageIdByUrl(siteStructure, url) {
    const baseUrl = platformUtils.getRGI().getNavigationInfo().baseUrl;
    const relativeUrl = _.replace(url, baseUrl, '');
    if (relativeUrl === '' || relativeUrl === '/') {
        return getMainPage(siteStructure).id;
    }

    try {
        return platformUtils.getLinkUtils().convertUrlToPageId(siteStructure.prefixes, relativeUrl, siteStructure.pages,
            platformUtils.isExperimentOpen.bind(platformUtils)); // TODO remove platformUtils.isExperimentOpen.bind(platformUtils) when merging bv_linkUtils_anchorlink_innerTpaRoute
    } catch(err) {
        return undefined;
    }
}

export default {
    getPageIdByLightboxName,
    getPageIdByUrl
};
